module.exports = __webpack_public_path__ + "img/19.0f2f6a6e.jpg";